import type { LayoutType } from '../../types';
import { useSocialFeedSettings } from '../utils';

const LAYOUTS_WITH_LOAD_MORE: LayoutType[] = ['grid', 'masonry', 'list'];

export function useDataLimit(): number | undefined {
  const {
    layout,
    limitTotalNumberOfItems,
    totalNumberOfItems,
    showLoadMoreButton
  } = useSocialFeedSettings();

  if (!limitTotalNumberOfItems || !totalNumberOfItems) {
    return undefined;
  }

  const needsLoadMore = LAYOUTS_WITH_LOAD_MORE.includes(layout);
  if (needsLoadMore && !showLoadMoreButton) {
    return undefined;
  }

  return totalNumberOfItems;
}
